/**
 * Sprint P32 · Cockpit color palettes & categorical hex maps.
 * Shared across BlockModelLayer, DrillholeIntervalLayer, InspectorPanel,
 * BlockLegend and DrillholeLegend.
 */

// ── Scientific colormaps (viridis-esque LUTs from matplotlib) ───────
export const COLORMAPS = {
  viridis:  ["#440154","#443983","#31688E","#21918C","#35B779","#8FD744","#FDE725"],
  inferno:  ["#000004","#1B0C41","#4A0C6B","#781C6D","#A52C60","#CF4446","#ED6925","#FB9A06","#F7D13C","#FCFFA4"],
  plasma:   ["#0D0887","#5B02A3","#9A179B","#CB4778","#EB7852","#FBB32F","#F0F921"],
  turbo:    ["#30123B","#4145AB","#4675ED","#42B7F3","#28CDCE","#75F14C","#D2F60B","#FFB528","#F65F1F","#B21801","#7A0403"],
  spectral: ["#9E0142","#D53E4F","#F46D43","#FDAE61","#FEE08B","#E6F598","#ABDDA4","#66C2A5","#3288BD","#5E4FA2"].reverse(),
};

// Fixed categorical palettes.
export const CLASS_HEX = {
  Measured: "#059669", Indicated: "#2563EB",
  Inferred: "#F59E0B", Unclassified: "#94A3B8",
};
export const PASS_HEX  = { 1: "#059669", 2: "#2563EB", 3: "#F59E0B", 0: "#94A3B8" };
export const ORE_HEX   = { ore: "#dc2626", waste: "#64748b" };
export const LITHO_HEX = {
  SOIL: "#a3a3a3", SAND: "#d6b26c", CLAY: "#c47f4a",
  GNS: "#7f8c8d", SCHT: "#8e6cd1", GRN: "#4b7a3a",
  DIORITE: "#c04a6b", DOLERITE: "#5b3f76",
  QVEIN: "#ffd166", CLOSS: "#b7c1cc",
};

export const hashHex = (str) => {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = str.charCodeAt(i) + ((h << 5) - h);
  return "#" + ((h >> 0) & 0xffffff).toString(16).padStart(6, "0").slice(0, 6);
};

export function pickColour(t, palette) {
  if (t <= 0) return palette[0];
  if (t >= 1) return palette[palette.length - 1];
  const idx = t * (palette.length - 1);
  return palette[Math.floor(idx)];
}
